import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../../context/LangContext";
import { BOOK_PATH, STRINGS } from "../../data/content";

export default function FinalCTA() {
  const { t } = useLang();
  return (
    <section className="final-cta" id="final">
      <div className="final-inner">
        <p className="final-slogan fade-in">{t(STRINGS.finalSlogan)}</p>
        <p className="final-text fade-in">{t(STRINGS.finalText)}</p>
        <Link to={BOOK_PATH} className="btn btn-inverse btn-large fade-in">
          {t(STRINGS.bookCallFree)}
        </Link>
      </div>
    </section>
  );
}
